import { render, staticRenderFns } from "./points_table.vue?vue&type=template&id=13dd8ddb&scoped=true&"
import script from "./points_table.vue?vue&type=script&lang=ts&"
export * from "./points_table.vue?vue&type=script&lang=ts&"
import style0 from "./points_table.vue?vue&type=style&index=0&id=13dd8ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd8ddb",
  null
  
)

export default component.exports